<div class="products">
    <p-table #dataTable
             styleClass="p-datatable-striped"
             [value]="primengTableHelper.records"
             rows="{{primengTableHelper.defaultRecordsCountPerPage}}"
             responsiveLayout="stack"
             [breakpoint]="'800px'"
             selectionMode="single"
             [(selection)]="selectedProduct"
             (onRowSelect)="onRowSelect($event)"
             (onRowUnselect)="onRowUnselect($event)"
             [resizableColumns]="primengTableHelper.resizableColumns">

        <ng-template pTemplate="caption">
            <div class="d-flex align-items-center justify-content-end">
                <ng-container *ngIf="!isAddMode">
                    <button class="btn btn-primary" (click)="addNewRow()">
                        <i class="fa fa-plus"></i>
                        {{ 'Add'| localize }}
                    </button>
                </ng-container>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>
                    <span translation="Axilla.FieldAgent.LocalWarehouse.THT" source="Axilla">
                    </span>
                </th>
                <th>
                    <span translation="Axilla.FieldAgent.LocalWarehouse.BatchNumber" source="Axilla">
                    </span>
                </th>
                <th style="width: 10em">
                    <span translation="Axilla.FieldAgent.LocalWarehouse.Amount" source="Axilla">
                    </span>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-record="$implicit">
            <tr [pSelectableRow]="record">
                <td>
                    <span class="p-column-title">{{ 'Axilla.FieldAgent.LocalWarehouse.THT' | localize }}</span>
                    {{ record.tht ? (record.tht | momentFormat: 'DD-MM-YYYY') : '-'}}
                </td>
                <td>
                    <span
                        class="p-column-title">{{ 'Axilla.FieldAgent.LocalWarehouse.BatchNumber' | localize }}</span>
                    {{ record.batchNumber }}
                </td>
                <td>
                    <span class="p-column-title">{{ 'Axilla.FieldAgent.LocalWarehouse.Amount' | localize }}</span>
                    {{ record.amount }}
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="summary">
            <div class="d-flex align-items-center justify-content-end" *ngIf="unspecified">
                <span class="p-2">
                    Unspecified: {{unspecified}}
                </span>
            </div>
        </ng-template>
    </p-table>


    <div class="primeng-no-data"
         *ngIf="primengTableHelper.totalRecordsCount == 0 && !primengTableHelper.isLoading && basket.length == 0">
        <span translation="Axilla.NoData" source="Axilla"></span>
    </div>
    <div class="primeng-no-data" *ngIf="primengTableHelper.isLoading">
        <span translation="Axilla.LoadingData" source="Axilla"></span>
    </div>
    <div class="spinner-container" style="z-index: 5;" *ngIf="primengTableHelper.isLoading">
        <p-progressSpinner></p-progressSpinner>
    </div>
</div>



